import { LiveWidgetTypes } from "@data-types/live-widget/LiveWidgetTypes";
import { AbstractWidgetElement } from "./AbstractWidgetElement";

export class LSWidgetElement extends AbstractWidgetElement {
	public type = LiveWidgetTypes.LS;
	public message?: {
		infoMessage?: string | null;
		errorMessage?: string | null;
	};
	public isStarted?: boolean;
}
